import App from './components/App';
import DevTools from './components/DevTools';
import Error from './components/Error';
import Initializer from './components/Initializer';
import LoadingBox from './components/LoadingBox';
import ThrowError from './components/ThrowError';
import { globalDebug } from './helpers/globalDebug';
import './i18n';
import './reset';
import { HIDE_CONSOLE_LOGS } from './settings';
import store from './store/store';
import './theme/index.scss';
import './theme/viewport.scss';
import { render } from 'preact';
import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

const Root = () => {
  useEffect(() => {
    if (HIDE_CONSOLE_LOGS) {
      globalDebug(false, true);
    }
  }, []);

  return (
    <>
      <BrowserRouter>
        <Provider store={store}>
          <Routes>
            <Route path="/">
              <Route index element={<ThrowError />} />
              <Route path=":id" element={<Initializer />} />

              <Route path="*" element={<Navigate to="/" />} />
            </Route>
          </Routes>

          <App />

          <LoadingBox />
          <Error />
          <DevTools />
        </Provider>
      </BrowserRouter>

      <Toaster
        position="bottom-center"
        toastOptions={{
          duration: 1500,
        }}
      />
    </>
  );
};

const start = () => {
  render(<Root />, document.getElementById('root'));
};

start();
